import { Alert, Button, Group, SimpleGrid, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTopic } from '../../context/TopicContext';
import { Topic } from '../../types/TopicModels';
import { primaryColor } from '../../constants/theme';
import { TopicCard } from './TopicCard';
import { TopicEditorModal } from './TopicEditorModal';

export const TopicsTabPanel = () => {
  const { topics, isLoading, error, fetchTopics } = useTopic();
  const [editorOpen, setEditorOpen] = useState(false);
  const [editingTopic, setEditingTopic] = useState<Topic | null>(null);

  useEffect(() => {
    fetchTopics();
  }, [fetchTopics]);

  return (
    <Stack gap="sm">
      <TopicEditorModal
        opened={editorOpen}
        onClose={() => {
          setEditorOpen(false);
          setEditingTopic(null);
        }}
        editingTopic={editingTopic}
        onSaved={() => fetchTopics()}
        onDeleted={() => fetchTopics()}
      />

      <Group justify="flex-end">
        <Button
          color={primaryColor}
          onClick={() => {
            setEditingTopic(null);
            setEditorOpen(true);
          }}
        >
          New Topic
        </Button>
      </Group>

      {error && (
        <Alert color="red" mb="sm">
          {error}
        </Alert>
      )}

      {isLoading && <Text c="dimmed">Loading topics...</Text>}

      {!isLoading && topics.length === 0 && (
        <Text c="dimmed">No topics yet. Create your first topic to get started.</Text>
      )}

      <SimpleGrid cols={{ base: 2, sm: 3 }} spacing="sm">
        {topics.map((topic) => (
          <TopicCard
            key={topic.id}
            topic={topic}
            variant="grid"
            onClick={() => {
              setEditingTopic(topic);
              setEditorOpen(true);
            }}
          />
        ))}
      </SimpleGrid>
    </Stack>
  );
};
